import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ReactElement } from "react";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

export const TanstackQueryClientProvider = ({
  children,
}: {
  children: ReactElement;
}) => {
  const shouldShowDevtools =
    process.env.NODE_ENV === "development" &&
    new URLSearchParams(window.location.search).get("tanstack") === "query";

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {shouldShowDevtools && (
        <ReactQueryDevtools
          buttonPosition="bottom-right"
          initialIsOpen={false}
          position="bottom"
        />
      )}
    </QueryClientProvider>
  );
};
